<template>
  <el-dropdown class="lang" trigger="click">
    <span class="el-dropdown-link lang-dropdown">{{ $t(`message.lang.${app.currentLan}`) }}<i
      class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <div @click="changeLan('zh-cn')">
          <el-dropdown-item>中文</el-dropdown-item>
        </div>
        <div @click="changeLan('en')">
          <el-dropdown-item>English</el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
<script>
import { mapGetters } from 'vuex';

import { postSwitchLanguage } from '@/components/lang/api/lang';
import { setI18nLanguage } from '@/language';
import GlobalData from '@/utils/global/index';

export default {
  computed: {
    ...mapGetters(['app']),
  },
  data() {
    return {};
  },
  methods: {
    changeLan(lang) {
      const language = lang === 'zh-cn' ? 'zh' : lang;
      postSwitchLanguage(language).then(async () => {
        setI18nLanguage(lang, this.$i18n);
        await GlobalData.getDictList([], true); // 刷新字典
        // location.reload();
        this.$router.go(0);
      }).catch(() => {
        setI18nLanguage(lang, this.$i18n);
      });
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/element-variables.scss';

.lang-dropdown {
  height: 19px;
  font-size: 14px;
  color: $color-text-primary;
  line-height: 19px;
  cursor: pointer;
  white-space: nowrap;
  .el-icon-arrow-down {
    color: $color-text-default-button;
    font-weight: 800;
    font-size: 14px;
    &.el-icon--right {
      margin-left: 8px;
    }
  }
}
@media screen and (max-width: 992px) {
  .lang-dropdown {
    font-weight: bold;
    .el-icon-arrow-down {
      margin-left: 0 !important;
      color: $color-text-primary;
    }
  }
}
</style>
